<template>
  <div v-if="this.$root.cookiePolicySelected === false">
    <div id="cookie-policy" class="cookie-policy-wrapper absolute h-full w-full">
      <div class="cookie-bg absolute h-full w-full">
      </div>
      <div class="cookie-policy flex flex-wrap fixed w-11/12 p-5 b-0 rounded-md text-center justify-center max-w-2xl sm:flex-col sm:items-center md:w-9/12 lg:flex-row">
        <p class="w-full mb-4">{{ this.$translations[this.$root.language].cookiePolicy }}</p>
        <button class="accept-cookies text-white mx-2 mb-5 p-3 rounded-sm w-8/12 sm:w-6/12 lg:w-3/12 lg:mb-0" @click="processCookiePolicy(true)">{{ this.$translations[this.$root.language].cookiePolicyAccept }}</button>
        <button class="reject-cookies text-white mx-2 mb-5 p-3 rounded-sm w-8/12 sm:w-6/12 lg:w-4/12 lg:mb-0" @click="processCookiePolicy(false)">{{ this.$translations[this.$root.language].cookiePolicyReject }}</button>
        <button class="personalize text-black mx-2 p-3 rounded-sm w-8/12 sm:w-6/12 lg:w-3/12" @click="cookiePersonalization()">{{ this.$translations[this.$root.language].personalize }}</button>
        <a href="/cookie-policy" target="_BLANK" class="cookie-link w-full mt-2">Privacy Policy</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .cookie-policy {
    background-color: #f3f0d3;
    color: black;
    z-index: 700;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .accept-cookies {
    background-color: #008300;
  }
  .reject-cookies {
    background-color: #9C1A1A;
  }
  .personalize {
    background-color: #ffffff;
  }
  .cookie-bg {
    background-color: black;
    opacity: 0.3;
    z-index: 600
  }
  .cookie-policy-wrapper {
    z-index: 500;
  }
  .cookie-link {
    color: #0645AD;
  }
</style>

<script>
  export default {
    name: 'cookie-policy',
    data: function () {
      return {
        url: ''
      }
    },
    methods: {
      processCookiePolicy (bool) {
        var xhr = new XMLHttpRequest()
        var dataObject = {}
        const keysArray = ['totalFarmSize', 'numberOfFields', 'workingWidthCurrent', 'numberOfSectionsCurrent', 'controlTypeCurrent',
        'costOfProduct', 'workingWidthFuture', 'numberOfSectionsFuture', 'controlTypeFuture', 'implementType', 'fieldSize', 'amountOfProduct', 'spreaderType']
        const googleAnalyticsKeysArray = ['_ga', '_gid', '_gat']
        var websiteCookiesArray = []
        var googleAnalyticsCookiesKeysArray = []
        // If our sessionStorage variables exist, use those values.
        keysArray.forEach(key => {
          if (document.cookie.split(';').some((item) => item.trim().startsWith(key + '='))) {
            websiteCookiesArray.push(key)
          }
        })

        googleAnalyticsKeysArray.forEach(key => {
          if (document.cookie.split(';').some((item) => item.trim().startsWith(key + '='))) {
            googleAnalyticsCookiesKeysArray.push(key)
          }
        })

        if (bool === true) {
          dataObject.websiteCookies = true
          dataObject.abstractCookies = true
          dataObject.googleAnalyticsCookies = true
        } else {
          dataObject.websiteCookies = false
          dataObject.abstractCookies = false
          dataObject.googleAnalyticsCookies = false
        }

        xhr.open('POST', '/submit-cookie-policy')
        xhr.setRequestHeader('Accept', 'application/json; charset=UTF-8')
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
        xhr.send(JSON.stringify({ dataObject, websiteCookieNames: websiteCookiesArray, googleAnalyticsCookieNames: googleAnalyticsCookiesKeysArray }))

        xhr.onloadend = response => {
          if (response.target.status === 200) {
            this.$root.cookiePolicySelected = true
            if (bool === true) {
              this.$root.allowAllCookies = true
              this.$root.websiteCookies = true
              this.$root.abstractCookies = true
              this.$root.googleAnalyticsCookies = true
              this.$root.essentialCookiesOnly = false
              this.$root.automaticLanguageSelect()
              this.$root.enableGoogleAnalytics()
            } else {
              this.$root.allowAllCookies = false
              this.$root.websiteCookies = false
              this.$root.abstractCookies = false
              this.$root.googleAnalyticsCookies = false
              this.$root.essentialCookiesOnly = true
            }
            var cookiePolicy = document.getElementById('cookie-policy')
            cookiePolicy.classList.add('hidden')
          }
          if (response.target.status !== 200) {
          }
        }
      },
      cookiePersonalization () {
        document.getElementById('cookie-personalization').classList.remove('hidden')
      }
    }
  }
</script>